import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import React, { useEffect, useRef, useState } from 'react';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import { adminLogin } from '@/api';
export default function LoginForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const t = useLocale(locale);
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);

  function afterLoginSuccess(params) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    localStorage.setItem('userStatus', 'login'); // 跳转首页

    window.location.href = '/';
  }

  function login(params) {
    setErrorMessage('');
    setLoading(true);
    adminLogin(params).then(res => {
      const {
        token
      } = res;

      if (token) {
        afterLoginSuccess(params);
        localStorage.setItem('token', token);
      } else {
        setErrorMessage(t['login.form.login.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  function onSubmitClick() {
    formRef.current.validate().then(values => {
      login(values);
    });
  } // 读取 localStorage，设置初始值


  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);

    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, "\u767B\u5F55\u540E\u53F0"), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, "\u8F93\u5165\u7BA1\u7406\u5BC6\u7801\u767B\u5F55\u540E\u53F0"), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      userName: 'admin',
      password: 'admin'
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "pass",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: "\u8BF7\u8F93\u5165\u7BA1\u7406\u5BC6\u7801",
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword'])), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']))));
}